<div class="space-y-4">
  <app-breadcrumbs [items]="breadcrumbItems" />

  <section class="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm sm:p-6">
    <div class="flex flex-wrap items-start justify-between gap-3 border-b border-slate-100 pb-4">
      <div class="rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-700">
        Showing <span class="font-semibold">{{ totalLogs() }}</span> events
      </div>
    </div>

    <div class="mt-5 space-y-4">
      <div class="grid gap-4 md:grid-cols-4">
        <div>
          <label class="mb-1 block text-sm font-medium text-slate-700">Event Type</label>
          <select
            [ngModel]="selectedEventType()"
            (ngModelChange)="selectedEventType.set($event)"
            class="w-full rounded-xl border border-slate-300 bg-white px-3 py-2.5 text-sm text-slate-900 outline-none focus:border-slate-500 focus:ring-2 focus:ring-slate-200"
          >
            <option value="all">All Event Types</option>
            @for (eventType of eventTypes(); track eventType) {
              <option [value]="eventType">{{ eventType }}</option>
            }
          </select>
        </div>

        <div>
          <label class="mb-1 block text-sm font-medium text-slate-700">Actor</label>
          <select
            [ngModel]="selectedActorUserId()"
            (ngModelChange)="selectedActorUserId.set($event)"
            class="w-full rounded-xl border border-slate-300 bg-white px-3 py-2.5 text-sm text-slate-900 outline-none focus:border-slate-500 focus:ring-2 focus:ring-slate-200"
          >
            <option [ngValue]="null">All Users</option>
            @for (user of users(); track user.id) {
              <option [ngValue]="user.id">{{ user.fullName }} ({{ user.role }})</option>
            }
          </select>
          @if (loadingUsers()) {
            <p class="mt-1 text-xs text-slate-500">Loading users...</p>
          }
        </div>

        <div>
          <label class="mb-1 block text-sm font-medium text-slate-700">Start Date</label>
          <input
            type="date"
            [ngModel]="selectedStartDate()"
            (ngModelChange)="selectedStartDate.set($event)"
            class="w-full rounded-xl border border-slate-300 bg-white px-3 py-2.5 text-sm text-slate-900 outline-none focus:border-slate-500 focus:ring-2 focus:ring-slate-200"
          />
        </div>

        <div>
          <label class="mb-1 block text-sm font-medium text-slate-700">End Date</label>
          <input
            type="date"
            [ngModel]="selectedEndDate()"
            (ngModelChange)="selectedEndDate.set($event)"
            class="w-full rounded-xl border border-slate-300 bg-white px-3 py-2.5 text-sm text-slate-900 outline-none focus:border-slate-500 focus:ring-2 focus:ring-slate-200"
          />
        </div>
      </div>

      <div class="flex flex-wrap justify-end gap-2">
        <button
          type="button"
          (click)="clearDateFilters()"
          class="rounded-xl border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
        >
          Clear Dates
        </button>
        <button
          type="button"
          (click)="applyFilters()"
          class="rounded-xl bg-slate-900 px-4 py-2 text-sm font-semibold text-white hover:bg-slate-800"
        >
          Apply Filters
        </button>
      </div>
    </div>

    @if (loading()) {
      <div class="mt-5 rounded-xl border border-slate-200 bg-slate-50 p-4 text-sm text-slate-600">
        Loading audit events...
      </div>
    } @else if (errorMessage()) {
      <div class="mt-5 rounded-xl border border-red-200 bg-red-50 p-4 text-sm text-red-700">
        {{ errorMessage() }}
      </div>
    } @else {
      <div class="mt-5 overflow-x-auto rounded-xl border border-slate-200">
        <table class="min-w-full divide-y divide-slate-200 text-sm">
          <thead class="bg-slate-50">
            <tr>
              <th class="px-3 py-2 text-left font-semibold text-slate-700">When</th>
              <th class="px-3 py-2 text-left font-semibold text-slate-700">Event</th>
              <th class="px-3 py-2 text-left font-semibold text-slate-700">Outcome</th>
              <th class="px-3 py-2 text-left font-semibold text-slate-700">Actor</th>
              <th class="px-3 py-2 text-left font-semibold text-slate-700">Message</th>
              <th class="px-3 py-2 text-left font-semibold text-slate-700">Metadata</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-slate-100 bg-white">
            @for (log of logs(); track trackByLogId($index, log)) {
              <tr>
                <td class="px-3 py-2 text-slate-700 whitespace-nowrap">{{ log.createdAt | date:'medium' }}</td>
                <td class="px-3 py-2 text-slate-900 font-medium">{{ log.eventType }}</td>
                <td class="px-3 py-2">
                  <span
                    class="rounded-full px-2 py-0.5 text-xs font-medium"
                    [class.bg-emerald-100]="log.outcome === 'success'"
                    [class.text-emerald-700]="log.outcome === 'success'"
                    [class.bg-red-100]="log.outcome === 'failure'"
                    [class.text-red-700]="log.outcome === 'failure'"
                    [class.bg-slate-100]="log.outcome === 'info'"
                    [class.text-slate-700]="log.outcome === 'info'"
                  >
                    {{ log.outcome }}
                  </span>
                </td>
                <td class="px-3 py-2 text-slate-700">{{ actorDisplayName(log) }}</td>
                <td class="px-3 py-2 text-slate-700">{{ log.message || '-' }}</td>
                <td class="px-3 py-2 text-slate-600">{{ metadataPreview(log) }}</td>
              </tr>
            } @empty {
              <tr>
                <td class="px-3 py-6 text-center text-slate-500" colspan="6">No audit events found for current filters.</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </section>
</div>
